skrilla.directive('userSummary', function () {
    return {
        templateUrl: 'directives/userSummary/userSummary.html',
        scope: {
            summary: "=",
            refresh: "="
        },
        controller: function ($scope, $stateParams, searchService) {
            $scope.summary.percentOfRevenueReceivedAsBonus = parseFloat($scope.summary.percentOfRevenueReceivedAsBonus).toFixed(2)
            $scope.summary.margin = parseFloat($scope.summary.margin).toFixed(2)

            $scope.futureDate = function (date) {
                return date && (new Date(date) > new Date())
            }

            searchService.get("users/excludedPersonClosedReasons").then(function (response) {
                $scope.excludedPersonReasons = response.data
            })

            $scope.excludedPersonReason = function (reason) {
                return $scope.excludedPersonReasons && $scope.excludedPersonReasons.includes(reason)
            }

            $scope.closedIndefinite = function (date) {
                date = date ? new Date(date) : null
                const indefiniteDate = new Date(new Date().setFullYear(2999))
                return date === null || date > indefiniteDate
            }

        }
    };
});
